module.exports = __webpack_public_path__ + "img/adhesivoGris.40e351e0.png";